import { render, staticRenderFns } from "./NewReceipt.vue?vue&type=template&id=069ff838&"
import script from "./NewReceipt.vue?vue&type=script&lang=js&"
export * from "./NewReceipt.vue?vue&type=script&lang=js&"
import style0 from "./NewReceipt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports